import React from 'react';
import {useSelector} from 'react-redux';

import Utility from '../../../../../util/utilityfunctions';
import {exportContacts} from '../../../../../util/uiconstants';
import {labels, currentResource} from '../../../../../util/utils';

import {IconoirCustomExport} from '@ey-xd/motif-icon';

import ExportToExcel from '../../../../Common/ExportToExcel/ExportToExcel';
import ToolbarButton from '../ToolbarButton';

const ExportTable = () => {
	const customColumns = useSelector((store) => store.project.customColumns);
	const entities = useSelector((store) => store.contacts?.displayedEntities);
	const customColumnsSort = Utility.sortListData(customColumns, 'name');

	const getExportDetails = () => {
		return {
			title: [labels.contactList],
			columns: getColumnsToExport(),
			data: getDataToExport(),
			worksheetName: labels.contactList
		};
	};

	const getColumnsToExport = () => {
		let columns = [];
		columns.push({header: labels.columnEntity, key: exportContacts.entityName});
		columns.push({header: labels.columnName, key: exportContacts.name});
		columns.push({header: labels.columnEmail, key: exportContacts.email});
		columns.push({header: labels.columnEngagement, key: exportContacts.engagements});
		columns.push({header: labels.columnServiceLine, key: exportContacts.serviceLine});
		columns.push({header: labels.columnRole, key: exportContacts.role});
		columns.push({header: labels.columnDashboard, key: exportContacts.accessDashboard});
		columns.push({header: labels.columnDashboardView, key: exportContacts.dashboardViews});
		columns.push({header: labels.columnContactList, key: exportContacts.accessContactlist});
		columns.push({header: labels.columnTags, key: exportContacts.tags});
		customColumnsSort.forEach((column) => {
			columns.push({header: column.name, key: column.name});
		});
		return columns;
	};

	const getDataToExport = () => {
		let data = [];
		entities.forEach((entity) => {
			entity?.contacts?.forEach((contact) => {
				const customColumnsData = {};
				if (contact.customColumns.length > 0) {
					contact.customColumns.forEach((column) => {
						return (customColumnsData[column.name] =
							column.options.length > 0
								? column.options
										.map((x) => x.option)
										.reduce((acc, cv, _, arr) => (arr.length > 1 ? acc + ';' + cv : cv))
								: '');
					});
				}
				data.push({
					entityName: entity.entityName,
					name: `${contact.name} ${contact.lastName}`,
					email: contact.emailAddress,
					engagements:
						contact.engagements.length > 0
							? contact.engagements?.map((engagement) => engagement.description).join('; ')
							: labels.manuallyAdded,
					serviceLine: contact.serviceLineName,
					role: contact.roleName,
					accessDashboard: contact.dashboard.length > 0 ? labels.yes : labels.no,
					dashboardViews:
						contact.dashboard.length > 0 ? contact.dashboard.map((dashboard) => dashboard).join('; ') : '',
					accessContactlist: contact.contactList?.hasAccess ? labels.yes : labels.no,
					tags: contact.tags
						.map((tag) => {
							return (
								currentResource.tags.find((t) => t.id?.toLowerCase() === tag?.key?.toLowerCase())?.name || tag?.name
							);
						})
						.join('; '),
					...customColumnsData
				});
			});
		});
		const sortedData = data.sort((a, b) => {
			return a?.entityName == b?.entityName
				? a?.name.localeCompare(b?.name)
				: a?.entityName.localeCompare(b?.entityName);
		});
		return sortedData;
	};

	const renderTrigger = ({onClick, disabled, title}) => {
		const props = {
			svg: IconoirCustomExport,
			label: title,
			disabled,
			onClick
		};

		return <ToolbarButton {...props} />;
	};

	return (
		<ExportToExcel
			buttonTitle={labels.toolbarExportData}
			getDataToExport={getExportDetails}
			customRender={renderTrigger}
		/>
	);
};

export default ExportTable;
